<template>
    <b-col class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm nguồn hình thành tài sản</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              label-for="input-string"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" :excluded="[2]"
                                                      v-model="searchForm.syncSourceType"
                                                      allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <!--<b-col offset-md="3" md="6">
                                <b-form-group label="Nhóm tài sản lớn:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect id="input-parentname"
                                                ref="assetTypeGroupTree"
                                                v-model="searchForm.assetTypeGroupId"
                                                :max-height="390"
                                                placeholder="Nhập tên nhóm tài sản lớn"
                                                :options="assetTypeGroups" />
                                </b-form-group>
                            </b-col>-->
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Loại tài sản áp dụng: "
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <treeselect v-model="searchForm.appliedAssetTypeGroupIds"
                                                multiple
                                                class="no-padding"
                                                placeholder="--- Tất cả ---"
                                                :options="assetTypeGroups" />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label="Mã/Tên nguồn hình thành tài sản:"
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input type="text" id="search"
                                                  placeholder="Nhập tên hoặc mã ..."
                                                  v-model="searchForm.str">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="3" md="6">
                                <b-form-group label=""
                                              label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>

                    <b-grid-tree :searchForm="searchForm"
                                 :gridOptions="gridOptions"
                                 dataUrl="master-data/asset-sources"
                                 gridName="Danh sách nguồn hình thành tài sản"
                                 ref="assetSourceTable">
                        <template v-slot:actions v-if="authorize(['ManageAssetSource']) && isBTCUser">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(appliedAssetTypeGroupIds)="row">
                            {{ (row.item.appliedAssetTypeGroupNames || []).join(', ') || 'Tất cả' }}
                        </template>
                        <template v-slot:cell(assetSourceGroup)="row">
                            {{ $store.getters.getAssetSourceGroupName(row.value) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <template v-if="authorize(['ViewAssetSource'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/detail`}" title="xem" variant="info">
                                        Xem
                                    </b-button>
                                </template>
                                <template v-if="authorize(['ManageAssetSource'])">
                                    <b-button size="sm" tag="button" variant="primary"
                                              :to="{ path: `./${row.item.id}/edit` }" title="sửa" class="mr5">
                                        Cập nhật
                                    </b-button>
                                    <b-button v-if="authorize(['ManageAssetSource'])" size="sm" @click.stop="remove(row.item.id, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid-tree>

                </b-card>
            </b-col>
        </b-row>
    </b-col>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListAssetSource',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    assetTypeGroupId: null,
                    str: null,
                    appliedAssetTypeGroupIds: [],
                    syncSourceType: this.getSyncSourceTypeCache(null, [2]),
                },
                assetSources: [],
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã nguồn hình thành', sortable: true },
                        { key: 'name', label: 'Tên nguồn hình thành', sortable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        { key: 'appliedAssetTypeGroupIds', label: 'Loại tài sản áp dụng', sortable: true, groupable: true, groupFormatter: (value, key, item) => (item.appliedAssetTypeGroupNames || []).join(', ') || 'Tất cả' },
                        //{ key: 'assetTypeGroupName', label: 'Nhóm tài sản lớn', sortable: false },
                        { key: 'assetSourceGroup', label: 'Nhóm nguồn gốc tài sản', sortable: true },
                    ],
                    sortBy: 'code'
                },
            }
        },
        computed: {
            ...mapState({
                assetTypes: (state, getters) => getters.assetTypeTreeLevel2,
                assetTypeGroups: (state, getters) => getters.assetTypeGroupTree,
            }),
        },
        watch: {

        },
        created() {
            //this.search();
        },
        methods: {
            search() {
                this.$refs.assetSourceTable.refresh();
            },
            //search() {
            //    var vm = this;
            //    this.$services.get('master-data/asset-sources', this.searchForm).done((data) => vm.assetSources = data);
            //},
            loadAssetSourceDetail() {
                var vm = this;
                if (this.assetSourceSelected) {
                    return this.$services.get(`master-data/asset-sources/${this.assetSourceSelected || ''}`).done(assetSource => {
                        vm.assetSource = assetSource;
                    });
                } else {
                    vm.assetSource = {};
                }
            },
            remove(id) {
                var vm = this;
                if (id) {
                    if (confirm('Bạn có chắc chắn muốn xóa nguồn hình thành này?')) {
                        this.$services.delete(`master-data/asset-sources/${id}`).done((response) => {
                            vm.$toastr.s('Xóa nguồn hình thành tài sản thành công !');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn nguồn hình thành cần xóa');
                }
            },
        }
    }
</script>
<!--scoped-->
<style scoped>

    .mr5 {
        margin-right: 5px;
    }

    .mt15 {
        margin-top: 15px;
    }

    .border {
        border-radius: 5px;
    }
</style>
